import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { useGetTopics } from "../../../api/queries";
import Skeleton from "../../../componentLibrary/Skeleton";
import { ModuleStatus } from "../../../types";

export default function UniversalResults({ searchTerm, setIsCollapsed }) {
  const navigate = useNavigate();

  const { data: modules, isError, isLoading } = useGetTopics();

  if (isLoading) return <Skeleton rows={3} />;

  const publishedModules =
    modules?.filter((module) => module.status === ModuleStatus.Published) || [];

  const publishedLessons = publishedModules.flatMap((module) =>
    module.lessons.map((lesson) => ({
      ...lesson,
      moduleId: module._id,
      moduleSlug: module.slug,
      moduleTitle: module.title,
    })),
  );

  const filteredLessons = searchTerm
    ? publishedLessons.filter((lesson) =>
        lesson.title.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : publishedLessons;

  const filteredModules = searchTerm
    ? publishedModules.filter(
        (module) =>
          module.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          module.lessons.some((lesson) =>
            lesson.title.toLowerCase().includes(searchTerm.toLowerCase()),
          ),
      )
    : publishedModules;

  return (
    <>
      <div className="space-y-1">
        <h3 className="text-base">Topics</h3>
        <hr className="border-t border-gray-900" />
        <ul className="space-y-2">
          {filteredModules.length > 0 && !isError ? (
            filteredModules.map((module) => (
              <li
                key={`module-${module._id}`}
                className="flex justify-between items-center space-x-1"
              >
                <span className="text-sm">{module.title}</span>
                <ArrowRightIcon
                  className="h-5 w-5 cursor-pointer flex-shrink-0"
                  onClick={() => {
                    setIsCollapsed(true);
                    navigate(`/topics/${module.slug ?? module._id}`);
                  }}
                />
              </li>
            ))
          ) : (
            <li className="text-sm">No topics found</li>
          )}
        </ul>
      </div>

      <div className="space-y-1">
        <h3 className="text-base">Sections</h3>
        <hr className="border-t border-gray-900" />
        <ul className="space-y-2 mt-4">
          {filteredLessons.length > 0 ? (
            filteredLessons.map((lesson) => (
              <li
                key={`lesson-${lesson._id}`}
                className="flex justify-between items-center space-x-1"
              >
                <span className="text-sm">{lesson.title}</span>
                <ArrowRightIcon
                  className="h-5 w-5 cursor-pointer flex-shrink-0"
                  onClick={() => {
                    navigate(
                      `/topics/${lesson.moduleSlug ?? lesson.moduleId}/sections/${lesson.slug ?? lesson._id}`,
                      {
                        state: {
                          referringPageName: lesson.moduleTitle,
                        },
                      },
                    );
                    setIsCollapsed(true);
                  }}
                />
              </li>
            ))
          ) : (
            <li className="text-sm">No sections found</li>
          )}
        </ul>
      </div>
    </>
  );
}
